import WidgetShellCard from "./WidgetShellCard";
import styles from "./Widget.module.css";

export default function StatCard({ title, value, unit, className }) {
    return (
        <WidgetShellCard title={title} className={`${styles.card} ${className}`}>
            <div className={styles.bill}>
                {unit && <span className={styles.bill__currency}>{unit}</span>}
                <span className={styles.bill__value}>{Number(value).toLocaleString()}</span>
            </div>
        </WidgetShellCard>
    );
}
